<template>
    <div class="about__box-text">
        <p class="about__text">
            {{
                getTranslatedText(
                    `If you choose two banker numbers (say, 12 and 18) and add three additional numbers (e.g., 3, 7, and 22), this will generate three lines:`,
                )
            }}
        </p>
        <ul class="about__box-list">
            <li class="about__box-item">
                <span class="about__text">
                    {{
                        getTranslatedText(`Line [line]: [number]`, {
                            line: '1',
                            number: '12, 18, 3',
                        })
                    }}
                </span>
            </li>
            <li>
                <span class="about__text">
                    {{
                        getTranslatedText(`Line [line]: [number]`, {
                            line: '2',
                            number: '12, 18, 7',
                        })
                    }}
                </span>
            </li>
            <li>
                <span class="about__text">
                    {{
                        getTranslatedText(`Line [line]: [number]`, {
                            line: '3',
                            number: '12, 18, 22',
                        })
                    }}
                </span>
            </li>
        </ul>
        <p class="about__text">
            {{
                getTranslatedText(
                    `If your stake is N10 per line and both banker numbers (12 and 18) are drawn, you will calculate your winnings per line:`,
                )
            }}
        </p>
        <ul class="about__box-list">
            <li class="about__box-item">
                <span class="about__text">
                    {{
                        getTranslatedText(
                            `Total winning = [symbol][price] * [line] lines * [multiplier] multiplier = [symbol][total]`,
                            {
                                symbol: $store.state.config.setup?.symbol,
                                price: `10`,
                                line: `2`,
                                multiplier: `240`,
                                total: `4,800`,
                            },
                        )
                    }}
                </span>
            </li>
        </ul>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';

export default {
    mixins: [languageMixins],
};
</script>
